import { createSlice } from "@reduxjs/toolkit";

export const mediaSlice = createSlice({
  name: "media",
  initialState: {
    media: [],
    showGallery: false,
    galleryIndex: 0,
  },
  reducers: {
    setMedia(state, action) {
      return {
        ...state,
        media: action.payload,
      };
    },
    setShowGallery(state, action) {
      return {
        ...state,
        showGallery: action.payload,
      };
    },
    setGalleryIndex(state, action) {
      return {
        ...state,
        galleryIndex: action.payload,
      };
    },
  },
});

const media = (state) => {
  return state.media.media;
};

const showGallery = (state) => {
  return state.media.showGallery;
};

const galleryIndex = (state) => {
  return state.media.galleryIndex;
};

export const selectors = {
  media,
  showGallery,
  galleryIndex,
};

export const { setMedia, setShowGallery, setGalleryIndex } = mediaSlice.actions;

export default mediaSlice.reducer;
